export function initFooter() {
    /** @type {HTMLButtonElement} */
    const cookieButton = document.querySelector('.page-footer-cookie-button');
    cookieButton.addEventListener('click', () => {
        window.c3cookie.openCookieWindow();
    });
}